import { useEffect, useState } from "react";
import { axiosFunction } from "../axiosFunction";
import { smaartCardUrl } from "../constant";

export const usePartnerState = () => {
  const [state, setState] = useState([]);

  useEffect(() => {
    const getState = async () => {
      const stateRes = await axiosFunction(
        `${smaartCardUrl}/location/api/allStates`,
        "GET",
        null
      );

      setState(stateRes?.data);
    };
    getState();
  }, []);

  return { state };
};
